import React, { useEffect, useState } from 'react';

import Modal from '../common/Modal';
import { DataCell, CommonModal } from '../../TableUIKit';
import { useSmsApi } from '../../auth/helper/api/smsApi';

const SmsTemplatePage = () => {



  const smsApi = useSmsApi();
  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState([]); // State for categories
  const [senderIds, setSenderIds] = useState([]); // State for senderIds
  const [encodingTypes, setEncodingTypes] = useState([]); // State for categories
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [newTemplate, setNewTemplate] = useState({
    smsTemplateId: '',
    smsTemplateName: '',
    smsTemplate: '',
    smsTemplateStatus: true,
    smsTemplateStage: '',
    smsTemplateCategory: null,
    categoryId: '',
    smsSender: null,
    senderId:'',
    smsEncodingType: ''
  });
  const [editingTemplate, setEditingTemplate] = useState(null); // Track which tempalte is being edited
  const [editSmsTemplateStage, setEditSmsTemplateStage] = useState("");
  const [editSmsSenderId, setEditSmsSenderId] = useState("");
  const [editSmsEncodingType, setEditSmsEncodingType] = useState("");

  // State for filters
  const [filters, setFilters] = useState({
    id: null,
    smsTemplateId: '',
    smsTemplateName: '',
    smsTemplate: '',
    smsTemplateStatus: '',
    smsTemplateStage: '',
    smsTemplateCategory: null,
  });

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  const [activeDetails, setActiveDetails] = useState(null);

  useEffect(() => {

    const fetchTemplates = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await smsApi.get(
          process.env
            .REACT_APP_GET_ALL_SMS_TEMPLATES_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters,
              page,
              size,
            },
          }
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setTemplates(object.content); // Set the templates from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching templates:', err);
        setError(err.message || 'An unexpected error occurred.'); // Provide error message to state
        setLoading(false);
      }
    };

    const fetchCategories = async () => {

      try {
        const response = await smsApi.get(
          process.env
            .REACT_APP_GET_ALL_SMS_CATEGORIES_ENDPOINT
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setCategories(object); // Set the templates from the response object
          console.log('categories:', categories);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        setLoading(false);

      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'Failed to load categories.');
        setLoading(false);
      }
    };
     const fetchSenderIds = async () => {

      try {
        const response = await smsApi.get(
          process.env
            .REACT_APP_GET_ALL_SMS_SENDERID_ACTIVE_ENDPOINT
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setSenderIds(object); // Set the templates from the response object
          console.log('senderIds:', senderIds);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        setLoading(false);

      } catch (err) {
        console.error('Error fetching senderIds:', err);
        setError(err.message || 'Failed to load senderIds.');
        setLoading(false);
      }
    };

    const fetchEncodingTypes = async () => {

      try {
        const response = await smsApi.get(
          process.env
            .REACT_APP_GET_ALL_SMS_TEMPLATE_ENCODING_TYPES_ENDPOINT
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setEncodingTypes(object); // Set the templates from the response object
          console.log('encodingTypes:', encodingTypes);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        setLoading(false);

      } catch (err) {
        console.error('Error fetching encodingTypes:', err);
        setError(err.message || 'Failed to load encodingTypes.');
        setLoading(false);
      }
    };

    fetchTemplates();
    fetchCategories();
    fetchSenderIds();
    fetchEncodingTypes();
  }, [smsApi, page, size]); // Dependency array is empty to run this effect once after the component mounts


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Special handling for category dropdown
    if (name === 'categoryId') {
      const selectedCategory = categories.find(
        (c) => String(c.id) === String(value)    // or match on templateCategory if needed
      );

      setNewTemplate((prev) => ({
        ...prev,
        categoryId: value,
        smsTemplateCategory: selectedCategory || null, // full object
      }));
      return;
    }
  // Special handling for senderId dropdown
    if (name === 'senderId') {
      const selectedSender = senderIds.find(
        (c) => String(c.senderId) === String(value)    // or match on templateCategory if needed
      );

      setNewTemplate((prev) => ({
        ...prev,
        senderId: value,
        smsSender: selectedSender || null, // full object
      }));
      return;
    }
    if (name === 'smsEncodingType') {
      const selectedEncodingType = Object.entries(encodingTypes)
              .find(([key, val]) => String(key) === String(value))?.[0];

      setNewTemplate((prev) => ({
        ...prev,
        smsEncodingType: selectedEncodingType || null, // full object
      }));
      return;
    }
    // Default handling (including checkboxes)
    setNewTemplate((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  const handleEditClick = (template) => {
    // Set the template being edited
    setEditingTemplate(template.id);
    setEditSmsTemplateStage(template.smsTemplateStage || "");
    setEditSmsEncodingType(template.smsEncodingType || "");
    setEditSmsSenderId(template.smsSender.senderId || "");
  };

  const handleEditSubmit = async (templateId) => {

    try {
      // Update template with PUT request

      await smsApi.put(
        `${process.env.REACT_APP_PUT_SMS_TEMPLATE_ENDPOINT}/${templateId}`,
        {
          smsTemplateStage: editSmsTemplateStage,
          smsEncodingType: editSmsEncodingType,
          smsSender: senderIds.find((c) => String(c.senderId) === String(editSmsSenderId))
        }
      );

      // Refresh the templates list after the update
      const updatedTemplates = templates.map((template) => {
        if (template.id === templateId) {
          return { ...template, smsTemplateStage: editSmsTemplateStage
                              , smsEncodingType:  editSmsEncodingType
                              , smsSender: senderIds.find((c) => String(c.senderId) === String(editSmsSenderId))}; 
                              // Update the edited template
        }
        return template; // Keep the other records unchanged
      });
      setTemplates(updatedTemplates);
      setEditingTemplate(null); // Reset editing state
      setEditSmsTemplateStage('')//clear
      setEditSmsEncodingType('')//clear('')//clear
      setEditSmsSenderId('')//clear('')//clear
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Template.');
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      console.log("newTempalte: ", newTemplate);
      const response = await smsApi.post(
        `${process.env.REACT_APP_SET_SMS_TEMPLATE_ENDPOINT}`,
        newTemplate
      );
      if (response.status === 200) {
        setTemplates((prev) => [...prev, response.data.object]); // Append the new template
        setNewTemplate({
          smsTemplateId: '',
          smsTemplateName: '',
          smsTemplate: '',
          smsTemplateStatus: true,
          smsTemplateStage: '',
          smsTemplateCategory: '',
          categoryId: '',
          smsSender: '',
          senderId:'',
          smsEncodingType: ''
        });
        setError(null); // Clear any previous errors
        setModalOpen(false); // Close modal after submission
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while creating the template.');
    }
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, smsTemplateStatus: statusValue };
      return newFilters;
    });
  };

  const toggleActivationStatus = async (templateId, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle activation status
      await smsApi.patch(
        `${process.env.REACT_APP_SET_SMS_TEMPLATE_STATUS_ENDPOINT}/${templateId}`,
        { status: newStatus }
      );
      // Update the local state after toggling the status
      setTemplates((prev) => prev.map(template =>
        template.id === templateId ? { ...template, smsTemplateStatus: newStatus } : template
      ));
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {
      const response = await smsApi.get(
        process.env
          .REACT_APP_GET_ALL_SMS_TEMPLATES_BY_PAGE_ENDPOINT,
        {
          params: {
            ...filters,
            page,
            size,
          },
        }
      );

      // Extract data from the response
      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) { // Check for successful status
        setTemplates(object.content); // Set the templates from the response object
        setTotalPages(object.totalPages);
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching templates:', err);
      setError(err.message || 'An unexpected error occurred.'); // Provide error message to state
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading templates: {error}</div>;

  return (
    <div className="template-table">
      <h2>SMS Templates</h2>
      <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>

      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>Id:</label>
          <input
            type="text"
            name="id"
            value={filters.id ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>smsTemplateId:</label>
          <input
            type="text"
            name="smsTemplateId"
            value={filters.smsTemplateId ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>smsTemplateName:</label>
          <input
            type="text"
            name="smsTemplateName"
            value={filters.smsTemplateName ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>


        <div className="filter-item">
          <label>Status:</label>
          <select name="smsTemplateStatus" onChange={handleStatusChange} value={filters.smsTemplateStatus === null ? '' : filters.smsTemplateStatus ? 'Active' : 'Inactive'}>
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div className="filter-item">
          <label>smsTemplateStage:</label>
          <input
            type="text"
            name="smsTemplateStage"
            value={filters.smsTemplateStage ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>smsTemplateCategory:</label>
          <input
            type="text"
            name="smsTemplateCategory"
            value={filters.smsTemplateCategory ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      {/* Button to open the modal */}
      <button onClick={() => setModalOpen(true)}>+ Create New</button>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="page-container">
          <h3>Create New SMS Template</h3>
          {/* Form for creating a new SMS Template */}
          <form onSubmit={handleSubmit} className="standard-form">
            <div className="form-group">
              <label>SMS Template ID:</label>
              <input
                type="text"
                name="smsTemplateId"
                value={newTemplate.smsTemplateId}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>SMS Template Name:</label>
              <input
                type="text"
                name="smsTemplateName"
                value={newTemplate.smsTemplateName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Category:</label>
              <select
                name="categoryId"
                value={newTemplate.categoryId}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a category</option>
                 {categories?.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.templateCategory}
                  </option>
                ))}
              </select>
            </div>

             <div className="form-group">
              <label>Sender ID:</label>
              <select
                name="senderId"
                value={newTemplate.senderId}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Sender ID</option>
                 {senderIds?.map((sender) => (
                  <option key={sender.senderId} value={sender.senderId}>
                    {sender.senderId}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>SMS Template Body:</label>
              <textarea
                name="smsTemplate"
                value={newTemplate.smsTemplate}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Activation Status:</label>
              <input
                type="checkbox"
                name="smsTemplateStatus"
                checked={newTemplate.smsTemplateStatus}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>SMS Template Stage:</label>
              <select
                name="smsTemplateStage"
                value={newTemplate.smsTemplateStage}
                onChange={handleInputChange}
              >
                <option value="">Select status</option>
                <option value="Approved">Approved</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>

            <div className="form-group">
              <label>SMS Encoding Type:</label>
              <select
                name="smsEncodingType"
                value={newTemplate.smsEncodingType}
                onChange={handleInputChange}
              >
                <option value="">Select Encoding</option>
                  {encodingTypes && Object.entries(encodingTypes).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
              </select>
            </div>

            <button type="submit">Create Template</button>
          </form>
        </div>
      </Modal>

      <h3>Existing SMS Templates</h3>
      {templates.length === 0 ? (
        <p>No templates available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>SMS Template ID</th>
                <th>Template Name</th>
                <th>Template Category</th>
                <th>Template Body</th>
                <th>Activation Status</th>
                <th>Template Stage</th>
                <th>Sender ID</th>
                 <th>Encoding Type</th>
                <th>Created At</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {templates.map((template) => (
                <tr key={template.id}>
                  <td>{template.id}</td>
                  <td>{template.smsTemplateId}</td>
                  <td>{template.smsTemplateName}</td>
                  <td>{template.smsTemplateCategory.templateCategory}</td>
                  <DataCell label="Template Body" value={template.smsTemplate} onClick={setActiveDetails} />
                  <td>{template.smsTemplateStatus ? 'Active' : 'Inactive'}</td>
                  <td>
                    {editingTemplate === template.id ? (
                      <select
                        value={editSmsTemplateStage}
                        onChange={(e) => setEditSmsTemplateStage(e.target.value)}
                      >
                        <option value="">Select status</option>
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    ) : (
                      // display value when not editing (you can prettify the text)
                      template.smsTemplateStage || "N/A"
                    )}
                  </td>
                  <td>
                     {editingTemplate === template.id ? (
                       <select
                          value={editSmsSenderId}
                          onChange={(e) => setEditSmsSenderId(e.target.value)}
                        >
                          <option value="">Select Sender ID</option>
                          {senderIds?.map((sender) => (
                            <option key={sender.senderId} value={sender.senderId}>
                              {sender.senderId}
                            </option>
                          ))}
                        </select>
                      ) : (
                      // display value when not editing (you can prettify the text)
                      template.smsSender.senderId || "N/A"
                    )}
                  </td>
                  <td>
                    {editingTemplate === template.id ? (
                      <select
                        value={editSmsEncodingType}
                        onChange={(e) => setEditSmsEncodingType(e.target.value)}
                      >
                        <option value="">Select Encoding</option>
                        {encodingTypes && Object.entries(encodingTypes).map(([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                  ))}
                      </select>
                    ) : (
                      // display value when not editing (you can prettify the text)
                      template.smsEncodingType || "N/A"
                    )}
                  </td>
                  <td>{new Date(template.createdTimestamp).toLocaleString()}</td>
                  <td>{new Date(template.updatedTimestamp).toLocaleString()}</td>
                  <td>{template.lastUpdatedBy}</td>

                  <td>
                    <div className="action-buttons">
                      {editingTemplate === template.id ? (
                        <button onClick={() => handleEditSubmit(template.id)}>Save</button> // Save edited sms template
                      ) : (
                        <button onClick={() => handleEditClick(template)}>Edit</button> // Set sms template
                      )}
                      <button onClick={() => toggleActivationStatus(template.id, template.smsTemplateStatus)}>
                        {template.smsTemplateStatus ? 'Disable' : 'Enable'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
       {/* ONE MODAL TO RULE THEM ALL */}
      <CommonModal
        isOpen={!!activeDetails}
        onClose={() => setActiveDetails(null)}
        /* Pull the dynamic title from state */
        title={activeDetails?.title || "Details"}
        copyValue={activeDetails?.text}
      >
        {activeDetails?.text}
      </CommonModal>
    </div>
  );
};

export default SmsTemplatePage;
